module.exports = __webpack_public_path__ + "static/img/brees-2008-slide-3.92c82fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-slide-3.jpg
// module id = ZaYp
// module chunks = 1